import React from "react";

const TabPanel = ({ children, value, name, ...rest }) => {
	// Keep panels mounted and toggle visibility instead of unmounting the
	// inactive one. Returning null here forced self-fetching panels
	// (Backups/GPT/Templates/PushNotifications) to remount and re-fetch on
	// every switch, collapsing the content area to zero height until data
	// landed and jittering the mobile scroll position.
	const hidden = value !== name;
	return (
		<div
			role="tabpanel"
			id={`simple-tabpanel-${name}`}
			aria-labelledby={`simple-tab-${name}`}
			hidden={hidden}
			style={hidden ? { display: "none" } : undefined}
			{...rest}
		>
			<>{children}</>
		</div>
	);
};

export default TabPanel;
